"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
var expression_1 = require("./expression");
var builder_1 = require("./builder");
var Message = /** @class */ (function (_super) {
    __extends(Message, _super);
    function Message(json) {
        var _this = _super.call(this, json) || this;
        _this.source = (0, builder_1.build)(json.source);
        _this.condition = (0, builder_1.build)(json.condition);
        _this.code = (0, builder_1.build)(json.code);
        _this.severity = (0, builder_1.build)(json.severity);
        _this.message = (0, builder_1.build)(json.message);
        return _this;
    }
    Message.prototype.exec = function (ctx) {
        var source = this.source.execute(ctx);
        var condition = this.condition.execute(ctx);
        if (condition) {
            var code = this.code.execute(ctx);
            var severity = this.severity.execute(ctx);
            var message = this.message.execute(ctx);
            var listener = ctx.getMessageListener();
            if (listener && typeof listener.onMessage === 'function') {
                listener.onMessage(source, code, severity, message);
            }
        }
        return source;
    };
    return Message;
}(expression_1.Expression));
exports.Message = Message;
//# sourceMappingURL=message.js.map